import React from "react";
import style from "./style.module.css";

/**
 * A cor do badge vem, historicamente, de seletores CSS em cima da string do
 * rótulo (`[data-status="Ativo"]`). Isso quebra em silêncio: rótulo novo sem
 * entrada no CSS renderiza branco no branco, sem erro nenhum.
 *
 * A prop `tone` permite dizer a cor explicitamente — necessário para os rótulos
 * de Vínculo, que são longos e variam. Sem `tone`, o comportamento antigo
 * continua valendo para todos os usos existentes.
 */
export default function StatusFlag(props) {
  const { status, children, tone, ...rest } = props;

  return (
    <span className={style.status} data-status={status} data-tone={tone} {...rest}>
      {children ?? status}
    </span>
  );
}
